/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {selectOption} from '../api'

export const useMutationSelectOption = createReactQueryMutationHook('selectOption', selectOption)
